import { ModelSagres } from "@/types/model-sagres";
import { UsuarioPerfil } from "./usuario-perfil";
export class UsuarioResumido extends ModelSagres {
  ID_USUARIO: number;
  NOME: string;
  CPF: string;
  INATIVO?: string;
  EMAIL?: string;
  USUARIO_PERFIL: UsuarioPerfil[];

  /**
   * Usar o parâmetro opcional para receber um objeto do importador de XML
   * @param obj
   */
  constructor(obj?: any) {
    super();
    //console.log(obj)
    if (obj) {
      this.ID_USUARIO = obj.IdUsuario;
      this.NOME = obj.Nome;
      this.CPF = obj.Cpf;
      this.INATIVO = obj.Inativo;
      this.EMAIL = obj.Email;

      //Novo
      if (obj.ID_USUARIO) this.ID_USUARIO = obj.ID_USUARIO;
      if (obj.CPF) this.CPF = obj.CPF;
      if (obj.NOME) this.NOME = obj.NOME;

      if (obj.USUARIO_PERFIL)
        this.USUARIO_PERFIL = obj.USUARIO_PERFIL.map(
          (up) => new UsuarioPerfil(up)
        );
    }
  }
}
